var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountCircleOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 7.45614 7.45614 4 12 4C16.5439 4 20 7.45614 20 12C20 16.5439 16.5439 20 12 20C7.45614 20 4 16.5439 4 12ZM2 12C2 17.5263 6.47368 22 12 22C17.5263 22 22 17.5263 22 12C22 6.47368 17.5263 2 12 2C6.47368 2 2 6.47368 2 12ZM14 10C14 11.2281 13.2281 12 12 12C10.7719 12 10 11.2281 10 10C10 8.77193 10.7719 8 12 8C13.2281 8 14 8.77193 14 10ZM16 10C16 7.78947 14.2105 6 12 6C9.78947 6 8 7.78947 8 10C8 12.2105 9.78947 14 12 14C14.2105 14 16 12.2105 16 10ZM17.2281 18.0702C15.8246 19.2982 14.0526 20 12 20C9.94737 20 8.17544 19.2982 6.77193 18.0702C8.05263 17.4035 9.85965 17 12 17C14.1404 17 15.9474 17.4035 17.2281 18.0702ZM20.1404 17.807C18.7368 16.1228 15.5965 15 12 15C8.40351 15 5.26316 16.1228 3.85965 17.807C5.64912 20.3158 8.63158 22 12 22C15.3684 22 18.3509 20.3158 20.1404 17.807Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircleOutlined);
export default __webpack_public_path__ + "static/media/account_circle_outlined.afd72412.svg";
export { ForwardRef as ReactComponent };